<template>
  <div></div>
</template>

<script>
export default {
  name: "ShipCategoryGatherers"
};
</script>

<style scoped></style>
